import { render, staticRenderFns } from "./PNPMsg.vue?vue&type=template&id=0ce01a64&lang=pug&"
import script from "./PNPMsg.vue?vue&type=script&lang=js&"
export * from "./PNPMsg.vue?vue&type=script&lang=js&"
import style0 from "./PNPMsg.vue?vue&type=style&index=0&id=0ce01a64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports